import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { onboardingAPI } from '../services/api';
import { useAuth } from '../App';

/**
 * OnboardingGate
 * Redirects employees who haven't completed onboarding to /onboarding/me.
 * HR/Admin/SuperAdmin/PayrollAdmin/Manager users bypass the gate.
 */
const OnboardingGate = ({ children }) => {
  const { user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only employees go through the gate
    if (!user || user.role !== 'employee') {
      setChecking(false);
      setAllowed(true);
      return;
    }

    // Already on the onboarding page — let them through
    if (location.pathname === '/onboarding/me') {
      setChecking(false);
      setAllowed(true);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await onboardingAPI.getMine();
        const data = res.data;
        if (cancelled) return;
        if (data.onboarding_required && data.status !== 'approved' && data.status !== 'active') {
          // Block portal, redirect to onboarding
          setAllowed(false);
          navigate('/onboarding/me', { replace: true });
        } else {
          setAllowed(true);
        }
      } catch {
        // If endpoint fails, fail-open so app remains usable
        setAllowed(true);
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();

    return () => { cancelled = true; };
  }, [user, location.pathname, navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!allowed) return null;
  return children;
};

export default OnboardingGate;
